/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../../../../helpers/restClient';

const verifyRecipientByTrackingNumber = async (payload) => {
      const { token, requestBody } = payload;
      const wcEnv = { 
         rootUri: '/retention',
         prefix: ''
      }
      const apiUri = `/ssp/selfservice/recipient-landing-page/verify/tracking-number`;
      const response = await restClient.postFacade(wcEnv, apiUri, token, requestBody)
      return response;
};

export default verifyRecipientByTrackingNumber;
